import { useEffect, useState } from "react";
import {
  AppDatePicker,
  AppMultiSelect,
  AppRemixIcon,
} from "@/layout/AppComponents";
import ReactDOMServer from "react-dom/server";
import axios from "axios";
import BtnOptions from "./BtnOptions";
import Translator from "../../../../components/helpers/Translator";
import UserSelectStates from "../../../../components/form/Selects/UserSelectStates";
import { axiosPath } from "../../../../../routing/helpers/router";
import _ from "lodash";

export default function Report54Options({
  handleOnSetFieldValue,
  handleOnSubmit,
  handleOnSave,
  selectedReport,
  values,
}) {
  const [isLoading, setIsLoading] = useState(true);
  const [reportOptions, setReportOptions] = useState();

  const [probSevOptions] = useState([
    {
      label: ReactDOMServer.renderToString(
        <Translator file="filter" name="filter.probability.0" />,
      ),
      value: 0,
    },
    {
      label: ReactDOMServer.renderToString(
        <Translator file="filter" name="filter.probability.1" />,
      ),
      value: 1,
    },
    {
      label: ReactDOMServer.renderToString(
        <Translator file="filter" name="filter.probability.2" />,
      ),
      value: 2,
    },
    {
      label: ReactDOMServer.renderToString(
        <Translator file="filter" name="filter.probability.3" />,
      ),
      value: 3,
    },
  ]);

  const [riskOptions] = useState([
    {
      label: ReactDOMServer.renderToString(
        <Translator file="filter" name="filter.probability.0.m" />,
      ),
      value: 0,
    },
    {
      label: ReactDOMServer.renderToString(
        <Translator file="filter" name="filter.probability.1.m" />,
      ),
      value: 1,
    },
    {
      label: ReactDOMServer.renderToString(
        <Translator file="filter" name="filter.probability.2.m" />,
      ),
      value: 2,
    },
    {
      label: ReactDOMServer.renderToString(
        <Translator file="filter" name="filter.probability.3.m" />,
      ),
      value: 3,
    },
  ]);

  // > LOAD REPORT OPTIONS //
  useEffect(() => {
    setIsLoading(true);
    setReportOptions(undefined);
    axios
      .post(axiosPath("api_r_user_module_intelligence_getReportOptions"), {
        report: 54,
        selectedReport,
        payload: values,
      })
      .then((r) => {
        setReportOptions(r.data);
      })
      .catch(() => "")
      .finally(() => setIsLoading(false));
  }, [selectedReport]);
  // < LOAD REPORT OPTIONS //

  return (
    <div>
      <div className="row">
        <div className="col-sm-12">
          <UserSelectStates
            onHandleChange={(opt) => {
              handleOnSetFieldValue("states", opt);
            }}
            value={values?.states}
            getPermissionsFrom="client"
            hasSelectOptions
            hideNotApplicable
            hideObsolete
          />
        </div>
      </div>
      <div className="row">
        <div className="col-sm-12">
          {reportOptions && (
            <AppMultiSelect
              options={reportOptions.categorieGroups ?? []}
              onChange={(e) => handleOnSetFieldValue("categorieGroups", e)}
              placeholder={ReactDOMServer.renderToString(
                <Translator
                  file="module-intelligence"
                  name="select.category.groups"
                />,
              )}
              title={
                <Translator file="module-intelligence" name="category.groups" />
              }
              value={values.categorieGroups || []}
              icon={<AppRemixIcon icon="apps" />}
              isMulti
              hasSearchBox
              hasSelectOptions
              isLoading={isLoading}
            />
          )}
        </div>
      </div>
      <div className="row">
        <div className="col-sm-12">
          <AppMultiSelect
            options={probSevOptions || []}
            title={ReactDOMServer.renderToString(
              <Translator file="filter" name="filter.probability" />,
            )}
            icon={<AppRemixIcon icon="numbers" />}
            value={values?.probability || []}
            onChange={(opt) =>
              handleOnSetFieldValue("probability", opt)
            }
          />
        </div>
      </div>
      <div className="row">
        <div className="col-sm-12">
          <AppMultiSelect
            options={probSevOptions || []}
            title={ReactDOMServer.renderToString(
              <Translator file="filter" name="filter.severity" />,
            )}
            icon={<AppRemixIcon icon="numbers" />}
            value={values?.severity || []}
            onChange={(opt) =>
              handleOnSetFieldValue("severity", opt)
            }
          />
        </div>
      </div>
      <div className="row">
        <div className="col-sm-12">
          <AppMultiSelect
            options={riskOptions || []}
            title={ReactDOMServer.renderToString(
              <Translator
                file="module-legalCompliance"
                name="module.lc.risk"
              />,
            )}
            icon={<AppRemixIcon icon="numbers" />}
            value={values?.risk || []}
            onChange={(opt) =>
              handleOnSetFieldValue("risk", opt)
            }
          />
        </div>
      </div>
      <div className="row">
        <div className="col-lg-6">
          <AppDatePicker
            title={<Translator file="module-intelligence" name="date1" />}
            value={values.date1}
            onChange={(date) => handleOnSetFieldValue("date1", date)}
            placeholder="mm/yyyy"
            dateFormat="MM/yyyy"
            displayDateFormat="MM/YYYY"
            isClearable
            showMonthYearPicker
          />
        </div>
        <div className="col-lg-6">
          <AppDatePicker
            title={<Translator file="module-intelligence" name="date2" />}
            value={values.date2}
            onChange={(date) => handleOnSetFieldValue("date2", date)}
            placeholder="mm/yyyy"
            dateFormat="MM/yyyy"
            displayDateFormat="MM/YYYY"
            isClearable
            showMonthYearPicker
          />
        </div>
      </div>
      <div className="row">
        <div className="col-12">
          <BtnOptions
            isDisabled={!values.date1 || !values.date2}
            handleOnSave={() => handleOnSave(true)}
            handleOnSubmit={() => handleOnSubmit()}
          />
        </div>
      </div>
    </div>
  );
}
